import { Navigation } from '@drycut/navigation';
import { ActionButtons, Button } from '@drycut/ui-components';

type Props = {
  className?: string;
  couponCode?: string;
  width?: number;
};

export default function CutNowButton({
  couponCode,
  width,
  className,
  ...props
}: Props): React.ReactElement {
  return (
    <ActionButtons className={className} width={width}>
      <Button as="a" href={Navigation.CUT_NOW_URL(couponCode)} {...props}>
        CUT NOW
      </Button>
    </ActionButtons>
  );
}
